export default "__VITE_PUBLIC_ASSET__7e9233bc__"